import React, { useState, useEffect, useRef } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { searchClientsAPI, ClientSearchResult } from '../../features/clients/services/clientsAPI';
import styles from './SearchBar.module.css';

interface SearchBarProps {
    onClientSelect: (client: { name: string, id: number }) => void;
    selectedCarteira: string;
}

const SearchBar: React.FC<SearchBarProps> = ({ onClientSelect, selectedCarteira }) => {
    const [query, setQuery] = useState('');
    const [results, setResults] = useState<ClientSearchResult[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showResults, setShowResults] = useState(false);

    const debounceTimeoutRef = useRef<NodeJS.Timeout | null>(null);

    const handleSelect = (client: ClientSearchResult) => {
        setQuery(client.NOME);
        setShowResults(false);
        onClientSelect({ name: client.NOME, id: client.ID });
    };

    const performSearch = async (searchQuery: string, carteiraId: string) => {
        if (searchQuery.length < 2) {
            setResults([]);
            return;
        }
        setIsLoading(true);
        try {
            const response = await searchClientsAPI(searchQuery, carteiraId);
            setResults(response.data);
        } catch (error) {
            console.error("Falha na busca:", error);
            setResults([]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        if (query.length > 1) {
            debounceTimeoutRef.current = setTimeout(() => {
                performSearch(query, selectedCarteira);
            }, 300);
        } else {
            setResults([]);
            setShowResults(false);
        }

        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, [query, selectedCarteira]);

    return (
        <div className={styles.searchContainer}>
            {/* Ícone de Lupa posicionado via CSS absolute */}
            <SearchIcon className={styles.searchIcon} sx={{ fontSize: 18 }} />

            <input
                type="text"
                value={query}
                onChange={(e) => {
                    setQuery(e.target.value);
                    setShowResults(true);
                }}
                onBlur={() => setTimeout(() => setShowResults(false), 200)}
                placeholder="Pesquisar cliente na carteira..."
                className={styles.searchInput}
            />

            {showResults && (query.length > 1) && (
                <ul className={styles.resultsList}>
                    {isLoading && <li className={styles.loadingItem}>Buscando...</li>}
                    {!isLoading && results.length === 0 && <li className={styles.noResultsItem}>Nenhum resultado.</li>}
                    {!isLoading && results.map(client => (
                        <li key={client.ID} onMouseDown={() => handleSelect(client)}>
                            {client.NOME}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default SearchBar;